// extracted by mini-css-extract-plugin
module.exports = {"caption":"CheckBox_caption__TbhgX","editor":"CheckBox_editor__7FL18","focusedLabel":"CheckBox_focusedLabel__1gDKL","unFocusedLabel":"CheckBox_unFocusedLabel__1kvBE"};